import stoneService from '@services/magento/stone.service';

import { Package } from '@stone/interfaces';

export async function fetchPackagesApi(): Promise<{ pending: Package[]; recent: Package[] }> {
  const [pendingRes, recentRes] = await Promise.all([
    stoneService.getStonePackagesPendingReceive({
      searchCriteria: {
        filterGroups: [],
        pageSize: 20,
        sortOrders: [{ field: 'created_at', direction: 'DESC' }],
      },
    }),
    stoneService.getStonePackages({
      // status = RECEIVED (3) AND parent_id IS NULL — separate filter_groups so Magento
      // ANDs across them. Filters within a single group are OR'd, which would have
      // returned every root package OR every received package (regardless of role).
      searchCriteria: {
        filterGroups: [
          { filters: [{ field: 'status', value: '3', condition_type: 'eq' }] },
          { filters: [{ field: 'parent_id', condition_type: 'null' }] },
        ],
        pageSize: 10,
        sortOrders: [{ field: 'received_at', direction: 'DESC' }],
      },
    }),
  ]);

  return {
    pending: Array.isArray(pendingRes) ? pendingRes : pendingRes?.items || [],
    recent: Array.isArray(recentRes) ? recentRes : recentRes?.items || [],
  };
}
